import React, { useState } from 'react';
import useStore from '../store/useStore';
import { sendTask } from '../services/api';

const TaskInput = () => {
  const [prompt, setPrompt] = useState('');
  const setCurrentTask = useStore((state) => state.setCurrentTask);
  const setResponse = useStore((state) => state.setResponse);
  const setLoading = useStore((state) => state.setLoading);
  const setActiveAgent = useStore((state) => state.setActiveAgent);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!prompt.trim()) return;

    setCurrentTask(prompt);
    setLoading(true);
    setResponse(null);
    setActiveAgent(null);

    try {
      const result = await sendTask(prompt);
      setResponse(result.output);
      setActiveAgent(result.agent);
      setPrompt('');
    } catch (error) {
      setResponse('Error: Failed to process task. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <textarea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        className="w-full p-3 rounded-lg border border-gray-600 bg-gray-800 text-white focus:outline-none focus:border-blue-500"
        placeholder="Enter your task here..."
        rows="4"
      />
      <button
        type="submit"
        className="self-end px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors disabled:opacity-50"
        disabled={useStore((state) => state.loading) || !prompt.trim()}
      >
        {useStore((state) => state.loading) ? 'Processing...' : 'Send Task'}
      </button>
    </form>
  );
};

export default TaskInput;
